(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/ContentShareRequest', '../model/GetShareLinkTypeResponse', '../model/Nothing'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ContentShareRequest'), require('../model/GetShareLinkTypeResponse'), require('../model/Nothing'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.ShareApi = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.ContentShareRequest, root.SmartCsV2Sdk.GetShareLinkTypeResponse, root.SmartCsV2Sdk.Nothing);
  }
}(this, function(ApiClient, ContentShareRequest, GetShareLinkTypeResponse, Nothing) {
  'use strict';

  /**
   * Share service.
   * @module api/ShareApi
   * @version 2.0.624
   */

  /**
   * Constructs a new ShareApi. 
   * @alias module:api/ShareApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the createShare operation.
     * @callback module:api/ShareApi~createShareCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'String'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:model/ContentShareRequest} request 
     * @param {module:api/ShareApi~createShareCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {Array.<'String'>}
     */
    this.createShare = function(request, callback) {
      var postBody = request;

      // verify the required parameter 'request' is set
      if (request == undefined || request == null) {
        throw "Missing the required parameter 'request' when calling createShare";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ['String'];

      return this.apiClient.callApi(
        '/v2/share', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getContentSharedWithUser operation.
     * @callback module:api/ShareApi~getContentSharedWithUserCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'String'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/ShareApi~getContentSharedWithUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {Array.<'String'>}
     */
    this.getContentSharedWithUser = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['String'];

      return this.apiClient.callApi(
        '/v2/share/shared_with_me', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getOwnerSharedContent operation.
     * @callback module:api/ShareApi~getOwnerSharedContentCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'String'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/ShareApi~getOwnerSharedContentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {Array.<'String'>}
     */
    this.getOwnerSharedContent = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['String'];

      return this.apiClient.callApi(
        '/v2/share/shared_by_me', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getShareLinkTypes operation.
     * @callback module:api/ShareApi~getShareLinkTypesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GetShareLinkTypeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.contentIds 
     * @param {module:api/ShareApi~getShareLinkTypesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/GetShareLinkTypeResponse}
     */
    this.getShareLinkTypes = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'contentIds': this.apiClient.buildCollectionParam(opts['contentIds'], 'csv')
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = GetShareLinkTypeResponse;

      return this.apiClient.callApi(
        '/v2/share', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the revokeSharedContent operation.
     * @callback module:api/ShareApi~revokeSharedContentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} shareId 
     * @param {module:api/ShareApi~revokeSharedContentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.revokeSharedContent = function(shareId, callback) {
      var postBody = null;

      // verify the required parameter 'shareId' is set
      if (shareId == undefined || shareId == null) {
        throw "Missing the required parameter 'shareId' when calling revokeSharedContent";
      }


      var pathParams = {
        'shareId': shareId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/share/{shareId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
